import { useEffect, useState } from 'react';

interface Props {
	ref: any;
}

interface ShiftEnterReturn {
	isShiftEnter: boolean;
	isEnter: boolean;
}

const useShiftEnter = ({ ref }: Props): ShiftEnterReturn => {
	const [isShiftEnter, setIsShiftEnter] = useState(false);
	const [isEnter, setIsEnter] = useState(false);

	// reset everything to false on blur so we don't inadvertently trigger the enter key
	useEffect(() => {
		if (!ref?.current) {
			return;
		}
		const innerRef = ref.current;
		const handleBlur = () => {
			setIsEnter(false);
			setIsShiftEnter(false);
		};
		innerRef.addEventListener('blur', handleBlur);

		return () => {
			innerRef.removeEventListener('blur', handleBlur);
		};

	}, [ref]);

	useEffect(() => {

		const handleEnter = (event: KeyboardEvent) => {
			if (document.activeElement === ref?.current) {
				if (event.key === 'Enter' && event.shiftKey) {
					setIsShiftEnter(true);
					setIsEnter(false);
					// hack to reset is enter to false in order to reset
					setTimeout(() => {
						setIsShiftEnter(false);
					}, 0);
				} else if (event.key === 'Enter' && !event.shiftKey) {
					setIsEnter(true);
					setIsShiftEnter(false);
					// hack to reset is enter to false in order to
					// prevent inadvertently triggering again
					setTimeout(() => {
						setIsEnter(false);
					}, 0);
					event.preventDefault();
				} else {
					setIsShiftEnter(false);
					setIsEnter(false);
				}
			}
		};

		document.addEventListener('keypress', handleEnter);
		document.addEventListener('keydown', handleEnter);

		return () => {
			document.removeEventListener('keypress', handleEnter);
			document.removeEventListener('keydown', handleEnter);
		};
	}, [ref]);

	return {
		isShiftEnter,
		isEnter,
	};
};

export default useShiftEnter;
